export default __webpack_public_path__ + "38c39ad630ed5b338f38e4dd2f6f0d5c.png";